import axios from "axios";
import deepParseJson from "../lib/deepParseJson";
import config from '../config/index'

const SpotService = axios.create({
    timeout: 60000,
    baseURL: config.SPOTAPI_URL
});

SpotService.interceptors.request.use(
    async (config) => {
        const rawPersistData = await localStorage.getItem("user_token");
        const persistData = deepParseJson(rawPersistData);
        if (persistData) {
            config.headers["Authorization"] = `${persistData}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export default SpotService;